"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3639],{

/***/ 95073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/is-valid-url.ts
var isValidUrl = function(url) {
    // Check if the url is a valid url or not.
    return /^https?:\/\//.test(url || "");
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx







/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "epyx9ne0"
})(function(param) {
    var theme = param.theme;
    return {
        objectFit: "cover"
    };
});
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // TODO: Check if the provided src is a valid url or not, if yes return it directly.
        var validUrl = isValidUrl(src.replace(/\/+$/, "").replace("/media/", ""));
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz");
        // if (rszHeight) {
        //   url += `&rsz[h]=${determineNewHeight(height, width, w)}`;
        // }
        if (grayscale) url += "&gsc=".concat(grayscale);
        // TODO: Remove the conditional logic after updating all the existing sites.
        return validUrl && src.includes("https://media-aws-dev.byorbit.com") ? src.replace("/media/", "") : validUrl ? src.replace("/media/", "").replace(/\/+$/, "") : url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader,
        height: "100%"
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 80830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 96410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SubscriptionModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47727);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(473);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87357);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18633);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43477);










var ModalContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e16465q70"
})(function() {
    return {
        background: "linear-gradient(0deg, #000000 0%, #191040b5 30%, rgba(0,212,255,0) 100%)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        cursor: "default",
        button: {
            transition: "0.01s",
            "&:hover": {
                background: "#3352fe",
                outline: "1px solid white"
            }
        }
    };
});
var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q71"
})(function() {
    return {
        fontSize: "54px",
        fontWeight: "600",
        textTransform: "uppercase",
        p: {
            color: "white"
        },
        "@media screen and (max-width: 800px)": {
            fontSize: "24px"
        }
    };
});
var HeaderSubText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q72"
})(function() {
    return {
        color: "orange",
        marginBottom: "16px"
    };
});
var LoginButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q73"
})(function() {
    return {
        position: "absolute",
        right: "16px",
        top: "16px",
        display: "block",
        "@media screen and (max-width: 800px)": {
            display: "none"
        }
    };
});
var PrimaryButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q74"
})(function() {
    return {
        background: "#3352fe",
        padding: "8px 24px",
        color: "white",
        fontSize: "18px"
    };
});
var StartButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q75"
})(function() {
    return {
        background: "#3352fe",
        padding: "12px 32px",
        color: "white",
        fontSize: "18px",
        "@media screen and (max-width: 800px)": {
            maxWidth: "calc(100% - 24px)"
        }
    };
});
var BoxContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "e16465q76"
})(function() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingBottom: 3,
        width: "80vw",
        height: "80vh",
        outline: "none",
        paddingTop: 2,
        background: 'url("/images/settings-bg.png")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        borderBottom: "2px solid #3352fe",
        "@media screen and (max-width: 800px)": {
            backgroundSize: "auto 100%"
        }
    };
});
var ListContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q77"
})(function() {
    return {};
});
var ListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q78"
})(function() {
    return {
        display: "flex",
        alignItems: "center",
        margin: "8px 0",
        color: "white",
        svg: {
            marginRight: "8px",
            height: "32px",
            width: "32px"
        }
    };
});
var TextUnderline = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e16465q79"
})(function() {
    return {
        cursor: "pointer",
        color: "white",
        textDecoration: "underline",
        "&:hover": {
            color: "#fafafa",
            textDecorationThickness: "2px"
        }
    };
});
var SubscriptionModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(true), 2), openState = ref[0], setOpenState = ref[1];
    var userToken = (0,_contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuthenticationContext */ .l)().userToken;
    var handleClose = function() {
        setOpenState(false);
    };
    var router = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var redirectAzcConnect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                router.push("/subscription/auth");
                return [
                    2
                ];
            });
        });
        return function redirectAzcConnect() {
            return _ref.apply(this, arguments);
        };
    }();
    return openState ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ModalContainer, {
        open: !userToken && openState,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(BoxContainer, {
            sx: {
                bgcolor: "background.paper",
                boxShadow: 24,
                px: 4
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(LoginButtonContainer, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PrimaryButton, {
                        color: "primary",
                        onClick: redirectAzcConnect,
                        children: "Login"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(HeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                marginTop: "24px",
                                marginBottom: 0
                            },
                            children: " Play all of huz."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                margin: "8px 0"
                            },
                            children: "Try us, cancel at anytime "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(HeaderSubText, {
                        children: "Enjoy and play unlimited online games for only $4.99/month"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ListContainer, {
                    children: [
                        "No Advirtesement",
                        "Unlimited gameplays",
                        "Cancel at anytime",
                        "Play on any device",
                        "Children Account", 
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(ListItem, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    style: {
                                        color: "green"
                                    }
                                }),
                                i
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                    style: {
                        position: "absolute",
                        bottom: "32px"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginBottom: "12px",
                                color: "white"
                            },
                            children: [
                                "HUZ is a subscription service. To see Terms and Conditions",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    href: "https://static.gamedistribution.com/terms/both.html",
                                    children: "click here."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(StartButtonContainer, {
                            color: "primary",
                            onClick: redirectAzcConnect,
                            children: "Start Your Game Adventure"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginTop: "12px",
                                color: "white"
                            },
                            children: [
                                "You can cancel anytime, ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    onClick: handleClose,
                                    children: "or try later"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {});
};


/***/ }),

/***/ 61546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Title/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_title_color",
                label: "General text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_title_color",
                label: "Title text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_link_hover_color",
                label: "Link text hover color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_title_link_active_color",
                label: "Link text active color",
                type: "color",
                default: theme.palette.action.active
            },
            {
                name: "theme_component_card_title_font_size",
                label: "Title font size",
                endAdornment: "px",
                type: "text",
                default: theme.typography.h2.fontSize
            },
            // 
            // {
            //   name: 'theme_component_title_padding',
            //   label: 'Padding',
            //   type: 'text',
            //   default: theme.spacing(1, 2),
            //   helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
            // },
            {
                name: "theme_component_title_lg_padding",
                label: "Padding for large screens",
                type: "text",
                default: theme.spacing(1, 2),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            // {
            //   name: 'theme_component_title_justify_content',
            //   label: 'Justify content',
            //   type: 'select',
            //   default: 'space-between',
            //   options: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
            // },
            // {
            //   name: 'theme_component_title_align_items',
            //   label: 'Align items',
            //   type: 'select',
            //   default: 'center',
            //   options: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
            // },
            {
                name: "theme_component_title_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                endAdornment: "px",
                default: 1
            },
            {
                name: "theme_component_title_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./src/components/Title/Title.tsx










var Title_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e15gjue10"
})(function(param) {
    var theme = param.theme;
    return {
        borderBottomWidth: theme.theme_component_title_border_bottom_width ? "".concat(theme.theme_component_title_border_bottom_width, "px") : 0,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_title_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_title_color || theme.palette.text.primary,
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        textTransform: "capitalize"
    };
});
var TypographyStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title_Typography, {
    target: "e15gjue11"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "none",
        color: theme.theme_component_title_title_color || "inherit",
        "& > a": {
            color: theme.theme_component_title_title_color || theme.palette.text.primary,
            "&:hover": {
                color: theme.theme_component_title_link_hover_color || theme.palette.action.hover
            },
            "&:active": {
                color: theme.theme_component_title_link_active_color || theme.palette.action.active
            }
        }
    };
});
var Title = function(props) {
    var disableGutters = props.disableGutters, children = props.children, className = props.className, style = props.style, childStyle = props.childStyle, other = (0,_object_without_properties/* default */.Z)(props, [
        "disableGutters",
        "children",
        "className",
        "style",
        "childStyle"
    ]);
    var titleRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: false,
        disableGutters: disableGutters,
        className: className,
        style: style
    }, useEditorHandlers("Title")), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: titleRef,
            style: childStyle
        }, other), {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/Title/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);